// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: how long voice mode waits before sending a message Konvo prepared for a Konvo
// chat. Mail, WhatsApp and Teams always wait for "send it", whatever is chosen here.

import styles from '@app/features/konvo_assistant/components/AssistantSpeechControls.module.css';
import AssistantSpeech, {
	VOICE_SEND_DELAYS,
	type VoiceSendDelay,
} from '@app/features/konvo_assistant/state/AssistantSpeech';
import {msg} from '@lingui/core/macro';
import {Trans, useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
import {useId} from 'react';

export const AssistantVoiceSendDelay = observer(() => {
	const {i18n} = useLingui();
	const id = useId();
	const label = (delay: VoiceSendDelay) =>
		delay === 0 ? i18n._(msg`Always ask`) : i18n._(msg`After ${delay} seconds`);
	return (
		<div className={styles.preferences} data-flx="konvo-assistant.voice-send-delay">
			<label htmlFor={`${id}-delay`}>
				<Trans>Send chat messages in voice mode</Trans>
			</label>
			<select
				id={`${id}-delay`}
				className={styles.select}
				value={AssistantSpeech.voiceSendDelay}
				onChange={(event) => AssistantSpeech.setVoiceSendDelay(Number(event.target.value) as VoiceSendDelay)}
			>
				{VOICE_SEND_DELAYS.map((delay) => (
					<option key={delay} value={delay}>
						{label(delay)}
					</option>
				))}
			</select>
			<p className={styles.hint}>
				<Trans>
					When Konvo prepares a message to a Konvo chat, it sends it after this pause unless you say "wait". Mail,
					WhatsApp and Teams always wait for you to say "send it". Saved on this device.
				</Trans>
			</p>
		</div>
	);
});
